import type {
  Box,
  Point,
  Resolution,
} from "@/features/Editor/Canvas/canvas-geometry";
import type { ElementDraft } from "@repo/video-engine-i2v/utils/element-draft";
import type { ElementDto } from "@repo/api/overlays";
import type { CanvasElement } from "./canvas-state";
import type { Guideline } from "./canvas-snapping";

const DRAG_THRESHOLD_SCREEN_PX = 5;

export type Modifiers = {
  shift: boolean;
};

// What a gesture knows about the press, captured when it starts.
export type PressContext = {
  start: Point;
  modifiers: Modifiers;
  canvasElements: CanvasElement[];
  elements: Record<string, ElementDto>;
  selectedIds: string[];
  resolution: Resolution;
  scale: number;
};

export type GestureOutput = {
  selectedIds?: string[];
  marquee?: Box;
  drafts?: Record<string, ElementDraft>;
  guidelines?: Guideline[];
};

export type Gesture = {
  press: (modifiers: Modifiers) => GestureOutput;
  drag?: (point: Point, modifiers: Modifiers) => GestureOutput;
  click: (modifiers: Modifiers) => GestureOutput;
};

export function isBeyondDragThreshold(
  start: Point,
  point: Point,
  scale: number,
) {
  const threshold = DRAG_THRESHOLD_SCREEN_PX / scale;

  return (
    Math.abs(point.x - start.x) > threshold ||
    Math.abs(point.y - start.y) > threshold
  );
}
